<mat-card>{{'subServices' | translate}}</mat-card>


<div align="end" class="row" style="padding:10px;">
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="createNew()">
        <mat-icon>add</mat-icon>
        {{'create' | translate}}
    </button>
</div>

<div class="container" style="padding: 25px;">

    <mat-grid-list cols="6" rowHeight="50px">

        <mat-grid-tile colspan="2">

            <mat-form-field appearance="standard">
                <mat-label>{{'mainServices' | translate}}</mat-label>
                <mat-select [(value)]="selectedMainService" (selectionChange)="selectMainserviceChange()">
                    <mat-option *ngFor="let item of mainServicesList" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'subCategoryStatus' | translate}}</mat-label>
                <mat-select [(value)]="selectedStatus" (selectionChange)="selectStatusChange()"
                    [disabled]="selectedMainService == null">
                    <mat-option *ngFor="let status of subServicestatus" [value]="status.id">
                        {{status.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'filter' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
            </mat-form-field>
        </mat-grid-tile>

    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- ID Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <!-- Progress Column -->
            <ng-container matColumnDef="arabicName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'arabicName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.arabicName}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="englishName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'englishName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.englishName}} </td>
            </ng-container>

            <!-- Color Column -->
            <ng-container matColumnDef="imgUrl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'image' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <img src="{{imagPath + row.imgUrl}}" alt="no image" width="80">
                </td>
            </ng-container>

            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> {{'edit' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="edit(row.id)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="onDelete(row.id)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>

<ng-template #Modal>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToDelete' | translate}}</p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial (click)="confirmDelete()">{{'yes' | translate}}</button>
    </div>

</ng-template>